import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { admin_service } from 'src/app/admin/services/admin.service';
import { ConstantService } from 'src/app/admin/services/constant.service';
import * as CryptoJS from 'crypto-js';
import { EncrDecrService } from "src/app/admin/services/encr-decr-service.service";
import { ChangeDetectorRef} from "@angular/core";
import { EncryptionDecryptionService } from 'src/app/admin/services/encryption-decryption.service';
import { param } from 'jquery';



@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetForm:any;
  userUnlockForm:any;
  constructor(private _Activatedroute:ActivatedRoute,    private fb: FormBuilder,
    private admin_service:admin_service,public router: Router,
    private enryptionService:EncrDecrService,
    private cd: ChangeDetectorRef,private encryptionDecryptionService:EncryptionDecryptionService
    ) { }

token:any;
password:any;
confirmPassword:any;
passwordMatch:boolean;
showspinner = false;
resetSuccessResponse:any;
resetErrorMsg:any;
passwordStrength:any=undefined;
strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
tokenValid:boolean=false;

resetFormValid:boolean=false;
unblockFormValid:boolean=false;
url:any;
toArray: any[]
passwordMatchVerify:boolean=false;
otpError:any;
resettoken: any;
encryptedPassword:any;
isValidateOTP:boolean=false;
pin:any;
isShowOTPErrorMsg:boolean=false;
apiBankingUserResetForm:any;
apiBankingUserFormValid:boolean=false;
dormantUserResetForm:any;
dormantUserResetFormValid:boolean=false;
validDormantUser:boolean=false;
showTimer:boolean = false;
showOtpErrMsg:boolean = false;
remainingText:any = '';
timerDuration:any = 180;
formattedTime:any = '';
isValidDormantUser:boolean = true;
showPasswordRestForm:boolean = true;
sendOtpMsg:any='Continue';
isContinueDisabled:boolean = false;

init() {
  this.password = "";
  this.confirmPassword = "";
  this.pin = "";
}

get f() {
  if(this.unblockFormValid){
    if (this.userUnlockForm != undefined) return this.userUnlockForm.controls;
  }else if (this.resetFormValid){
    if (this.resetForm != undefined) return this.resetForm.controls;
  }else if (this.apiBankingUserFormValid){
    if (this.apiBankingUserResetForm != undefined) return this.apiBankingUserResetForm.controls;
  }else if (this.dormantUserResetFormValid){
    if (this.dormantUserResetForm != undefined) return this.dormantUserResetForm.controls;
  }
}

// analyzePassword(value){
//   if(this.strongRegex.test(value)) {
//     this.passwordStrength ="green";
// } else if(this.mediumRegex.test(value)) {
//     this.passwordStrength = "orange";
// } else {
//     this.passwordStrength = "red";
// }
// }

  ngOnInit(): void {

    //before url changes following code snnipet was used.
    //   this._Activatedroute.paramMap.subscribe(params => { 
    //     this.token = params.get('token'); 
    // }); 
    
    this._Activatedroute.queryParams.subscribe(queryparam => { 
    this.token = queryparam['token'];
   // console.log('token ["token"]',queryparam['token']);           
    //console.log('token queryparam["token"]', this.token);
  }); 

  /**Get URL */
    this.url = this.router.url;
    //console.log("this.url reset password", this.url);

    // Find the index of the "?" and trim the URL if necessary
    let queryIndex = this.url.indexOf('?');
    //console.log("query index", queryIndex);

    // Trim the URL up to "?"
    if (queryIndex !== -1) {
      this.url = this.url.substring(0, queryIndex); 
    }
    //console.log("this.url after query index", this.url);

    // Split the trimmed URL into an array
    this.toArray = this.url.split("/");
    //console.log("array before iteration", this.url);
 

 
  for (let i = 0; i < this.toArray.length; i++) {
    //console.log("array after iteration",this.toArray[i]);
    if(this.toArray[i]=='reset-password'){
        this.resetFormValid = true;
        break;
    }else if(this.toArray[i] == 'unlock-user'){
        this.unblockFormValid = true;
        break;
    }else if(this.toArray[i]==='api-banking-reset-password') {
      this.apiBankingUserFormValid = true;
    }else if(this.toArray[i]==='dormant-user-reset-password') {
      this.dormantUserResetFormValid = true;
    }
  }

if(this.resetFormValid){
  this.resetForm = this.fb.group({
    password: ["", [Validators.required,
    Validators.pattern(this.strongRegex),
    Validators.minLength(8)]],             
    confirmPassword: ["", [Validators.required]],
  });
}

if(this.unblockFormValid){
  this.userUnlockForm = this.fb.group({
    password: ["", [Validators.required,
    Validators.pattern(this.strongRegex),
    Validators.minLength(8)]],             
    confirmPassword: ["", [Validators.required]],
    pin: ["", [Validators.required]],
    mode:["EMAIL", [Validators.required]]
  });
}

if(this.apiBankingUserFormValid){
  this.apiBankingUserResetForm = this.fb.group({
    password: ["", [Validators.required,
    Validators.pattern(this.strongRegex),
    Validators.minLength(8)]],             
    confirmPassword: ["", [Validators.required]],
  });
}

if(this.dormantUserResetFormValid){
  this.dormantUserResetForm = this.fb.group({
    password: ["", [Validators.required,
    Validators.pattern(this.strongRegex),
    Validators.minLength(8)]],             
    confirmPassword: ["", [Validators.required]],
    mode: ["EMAIL", [Validators.required]]
  });
}

if (!this.apiBankingUserFormValid && !this.dormantUserResetFormValid) {
  this.validateToken();
}
 


  }
  comparePasswords(){
    if(this.f.password.value == this.f.confirmPassword.value){
      this.passwordMatch=true;
    }else{
      this.passwordMatch=false;
    }
  }
  navigateToLogin(){
    this.router.navigateByUrl("/");  

  }
  disableResetForm(){
    this.resetForm.controls['password'].disable();
    this.resetForm.controls['confirmPassword'].disable();
  }

  disableApiBankingResetForm(){
    this.apiBankingUserResetForm.controls['password'].disable();
    this.apiBankingUserResetForm.controls['confirmPassword'].disable();
  }

  disableDormantResetForm(){
    this.dormantUserResetForm.controls['password'].disable();
    this.dormantUserResetForm.controls['confirmPassword'].disable();
    this.dormantUserResetForm.controls['mode'].disable();
  }

  validateToken(){
    this.admin_service
    .validateResetToken(this.token.toString())
    .subscribe((res) => {
    
        if (res.code == "200") {
          this.tokenValid=true;
        }else{
          this.tokenValid=false;
          this.resetErrorMsg  = res.message;
          this.resetSuccessResponse  = undefined;
        }
      
    },err =>{
      this.tokenValid=false;
      this.resetErrorMsg  = err.error.message;
      this.resetSuccessResponse  = undefined;
     
    }
    );

  }

  //========================= User unlock methods ========================

  /**Disable Password Form */
  disableUserResetForm(){
    this.userUnlockForm.controls['password'].disable();
    this.userUnlockForm.controls['confirmPassword'].disable();
    this.userUnlockForm.controls['mode'].disable();
  }

  /** send OTP Call */
sendOTP(){
  this.admin_service.sendOTP({token:this.token.toString(),mode: this.f.mode.value.trim()}).subscribe((res) => {
    
      if (res.code == "200") {
        this.passwordMatchVerify=true;
        
        this.startTimer();
        this.isContinueDisabled = true;
        this.sendOtpMsg = 'Resend Otp'
        this.showTimer = true;
        this.isValidateOTP=true;
        //this.otpError="OTP Send to Register Mobile number.";
      }else{
        this.isShowOTPErrorMsg=true;
        this.isValidateOTP=false;
        this.otpError="Unable to send OTP.";
      }
     
  },err =>{
    this.isShowOTPErrorMsg=true;
    this.isValidateOTP=false;
    this.otpError="Unable to send OTP";
   
  }
  );
}
  /** validate password & send OTP */

  validatePasswordAndSendOTP(){
    this.comparePasswords();
    this.f.password.markAsTouched();
    this.f.confirmPassword.markAsTouched();
    this.f.mode.markAsTouched();
    var secret = ConstantService.encryptionSecret;
    this.encryptedPassword =this.encryptionDecryptionService.encryptedPassword(this.f.password.value);
    if(this.passwordMatch && this.f.password.value.trim() != null){
      this.disableUserResetForm();
      this.sendOTP();
    }else{
      return;
    }
    
  }

  //Validate OTP Call
  validateOTP(){
    
    this.isShowOTPErrorMsg=false;
    if (this.pin == null || this.pin == undefined || this.pin == "") {
      this.isShowOTPErrorMsg=true;
      this.otpError= "Please enter a valid PIN";
      var status = "error";
      return;
    }else {
      this.isShowOTPErrorMsg=false;
      this.showspinner = true;
      this.admin_service.checkOTPForUserUnlock({otp:this.pin}).subscribe((res) => {
        
   
        if(res.code=="200")
        {
            
            this.enryptionService.decryptAESGCM(res.message)
            .then((value: string)=>{
            var arrayData=value.split(";");
           
            var otpVerifiedStatus=ConstantService.OTP_VERIFIED_STATUS;
            var otpStatus=arrayData[0];
            

            if(otpStatus==otpVerifiedStatus){
              var encryptionTimeString=arrayData[1];
              var currentTime = Date.now();
              var validDate = Number((Number(encryptionTimeString) + Number(120000)));          
                localStorage.setItem("pin","yes");
                this.showspinner = true;
                this.userUnblock();//Call User Unblock
                
            }//-- otpSatatus End
            else{
              this.showspinner = false;
              this.isShowOTPErrorMsg=true;
              this.otpError="Invalid OTP."; 
            }
            });
          }//--HTTP Code END
          else{
            this.showspinner = false;
            this.isShowOTPErrorMsg=true;
            this.otpError="Invalid OTP."; 
          }
        }, //API Call End
        err=>{
          this.showspinner = false;
          this.isShowOTPErrorMsg=true;
             this.otpError="Unable Validate OTP";
        }); //Close API
      }

  }

  //user unblock call
  userUnblock(){
    this.showTimer = false;
    if(this.encryptedPassword != null){
      this.admin_service
      .resetNewPasswordAndUserUnlock( {token:this.token.toString(),password:this.encryptedPassword.toString()})
      .subscribe((res) => {
        if (res.code == "200") {
          this.resetSuccessResponse  = res.message;
          this.showspinner = false;
          this.resetErrorMsg  = undefined;
          this.disableResetForm();
        }else{
          this.showspinner = false;
          this.resetErrorMsg  = res.message;  
          this.resetSuccessResponse  = undefined;
        }
      },err =>{
        this.showspinner = false;
        this.resetErrorMsg  = err.error.message;
        this.resetSuccessResponse  = undefined;
        
      }
      );//End Api call
    }else{

      return;

    }
    
  }


//======================= user unlock End ====================================

  validateResetPassword(){
    this.comparePasswords();

    
    this.f.password.markAsTouched();
    this.f.confirmPassword.markAsTouched();
    var secret = ConstantService.encryptionSecret;//"YblSonSheNeebal";
    // var encryptedPassword = CryptoJS.AES.encrypt(this.f.password.value, secret);
    var encryptedPassword = this.encryptionDecryptionService.encryptedPassword(this.f.password.value);
    

    if(this.resetForm.valid && this.passwordMatch){
      this.showspinner = true;
      this.admin_service
        .resetNewPassword( {token:this.token.toString(),password:encryptedPassword.toString()})
        .subscribe((res) => {
        
            if (res.code == "200") {
              this.resetSuccessResponse  = res.message;
              this.showspinner = false;
              this.resetErrorMsg  = undefined;
              this.disableResetForm();
            }else{
              this.showspinner = false;
              this.resetErrorMsg  = res.message;  
              this.resetSuccessResponse  = undefined;
    
            }
          
        },err =>{
          this.showspinner = false;
          this.resetErrorMsg  = err.error.message;
          this.resetSuccessResponse  = undefined;
          
        }
        );
  
    }  
    else{
      return;
    }
  
  }


  apiBankingResetPassword(){
    this.comparePasswords();

    
    this.f.password.markAsTouched();
    this.f.confirmPassword.markAsTouched();
    var secret = ConstantService.encryptionSecret;//"YblSonSheNeebal";
    //var encryptedPassword = CryptoJS.AES.encrypt(this.f.password.value, secret);
    var encryptedPassword = this.encryptionDecryptionService.encryptedPassword(this.f.password.value);


    if(this.apiBankingUserResetForm.valid && this.passwordMatch){
      this.showspinner = true;
      this.admin_service
        .resetApiBankingNewPassword( {token:this.token.toString(),password:encryptedPassword.toString()})
        .subscribe((res) => {
        
            if (res.code == "200") {
              this.resetSuccessResponse  = res.message;
              this.showspinner = false;
              this.resetErrorMsg  = undefined;
              this.disableApiBankingResetForm();
            }else{
              this.showspinner = false;
              this.resetErrorMsg  = res.message;  
              this.resetSuccessResponse  = undefined;
            }
        },err =>{
          this.showspinner = false;
          this.resetErrorMsg  = err.error.message;
          this.resetSuccessResponse  = undefined;
          
        }
        );
  
    }  
    else{
      return;
    }
  
  }

  dormantUserResetPassword(){
    this.comparePasswords();

    
    this.f.password.markAsTouched();
    this.f.confirmPassword.markAsTouched();
    this.f.mode.markAsTouched();
    var secret = ConstantService.encryptionSecret;//"YblSonSheNeebal";
    //var encryptedPassword = CryptoJS.AES.encrypt(this.f.password.value, secret);
    var encryptedPassword = this.encryptionDecryptionService.encryptedPassword(this.f.password.value);

    if(this.dormantUserResetForm.valid && this.passwordMatch){
      this.showspinner = true;
      this.admin_service
        .resetNewPasswordForDormantUser( {token:this.token.toString(),password:encryptedPassword.toString(),mode: this.f.mode.value.trim()})
        .subscribe((res) => {
        
            if (res.code == "200") {
              // this.resetSuccessResponse  = res.message;
              this.showspinner = false;
              this.resetErrorMsg  = undefined;
              this.disableDormantResetForm();
              this.validDormantUser = true;
              this.startTimer();
              this.showTimer = true;
              this.isValidDormantUser=false;
              this.showPasswordRestForm =false;
              this.isContinueDisabled = true;
            }else{
              this.showspinner = false;
              this.resetErrorMsg  = res.message;  
              this.resetSuccessResponse  = undefined;
            }
        },err =>{
          this.showspinner = false;
          this.resetErrorMsg  = err.error.message;
          this.resetSuccessResponse  = undefined;
         
        }
        );
  
    }  
    else{
      return;
    }
  
  }

  startTimer() {
    const timerInterval = setInterval( () => {
      this.timerDuration--;
      const minutes = Math.floor(this.timerDuration / 60);
      const seconds = this.timerDuration % 60;
      this.remainingText = 'Remaining Time : '
      this.cd.detectChanges();
      this.formattedTime = `${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`;

      if (this.timerDuration <= -1) {
        this.formattedTime = 'OTP expired.';
        this.showTimer = false;
        this.showOtpErrMsg = true;
        this.validDormantUser = false;
        this.passwordMatchVerify = false;
        this.timerDuration = 180;
        this.sendOtpMsg = 'Resend Otp';
        this.isContinueDisabled = false;
        this.cd.detectChanges();
        clearInterval(timerInterval);
      }
    },1000);
  }

  checkOtpDormant() {
     var secret = ConstantService.encryptionSecret;//"YblSonSheNeebal";
    // var encryptedPassword = CryptoJS.AES.encrypt(this.f.password.value, secret);
    var encryptedPassword = this.encryptionDecryptionService.encryptedPassword(this.f.password.value);

    
    if (this.pin == null || this.pin == undefined || this.pin == "") {
      this.otpError= "Please enter a valid PIN";
      var status = "error";
 return;
    } else {
      this.admin_service.checkOTPForDormantUser({otp:this.pin,token:this.token.toString(),password:encryptedPassword.toString()}).subscribe((res) => {
        
        //const secret=ConstantService.encoded16ByteSecret;//"SGlTb011TWFKYVNhUGFTYQ==";//"HiSoMuMaJaSaPaSa";

          if(res.code=="200"){

            this.enryptionService.decryptAESGCM(res.message)
            .then((value: string)=>{
             
              var arrayData=value.split(";");
              
              var otpVerifiedStatus=ConstantService.OTP_VERIFIED_STATUS;
              var otpStatus=arrayData[0];
              
  
              if(otpStatus==otpVerifiedStatus){
                this.resetSuccessResponse = 'Password Reset Successfully';
                this.validDormantUser=false;
              }// --date condition end
              else{
                this.otpError="Invalid OTP."; 
                
              }
            });
          }//-- otpSatatus End
          else if(res.code ==="400") {
            this.resetErrorMsg="Unable to validate OTP."
          } else if(res.code=="210") {
            this.resetErrorMsg = 'Invalid OTP';
          }
      }, err=>{ 
        this.otpError="Unable Validate OTP";
        this.resetErrorMsg = "Something went wrong."
      });
    
    
    }
  }

}